import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { EllipsisHorizontalIcon } from '@heroicons/react/20/solid';

export type SkuMenuOption = {
  label: string;
  action: () => void;
  isDisabled?: boolean;
  disabledMessage?: string;
};

export function SkuActionsMenu({
  id,
  options,
}: {
  id: string;
  options: SkuMenuOption[];
}) {
  return (
    <Menu>
      <MenuButton
        type='button'
        aria-label='Open menu'
        onClick={(e) => e.stopPropagation()}
        className='flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 transition-colors hover:bg-gray-50'
      >
        <EllipsisHorizontalIcon className='h-5 w-5' />
      </MenuButton>
      <MenuItems
        anchor='bottom end'
        className='z-[1200] mt-1 w-36 rounded-md border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none'
      >
        <MenuItem>
          <button
            type='button'
            className='w-full px-4 py-2 text-left data-[focus]:bg-gray-100'
            onClick={(e) => {
              e.stopPropagation();
              navigator.clipboard?.writeText(id);
            }}
          >
            Copy id
          </button>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.label} disabled={option.isDisabled}>
            <button
              type='button'
              title={option.isDisabled ? option.disabledMessage : undefined}
              className='w-full px-4 py-2 text-left data-[focus]:bg-gray-100 data-[focus]:text-blue-600 data-[disabled]:cursor-not-allowed data-[disabled]:text-gray-400'
              onClick={(e) => {
                e.stopPropagation();
                option.action();
              }}
            >
              {option.label}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
}
